import { Injectable, inject } from '@angular/core'
import type { TaskSettings } from '@awork/features/task/models/task-settings.model'
import { TaskSettingsStore } from '@awork/features/task/state/task-settings.store'
import { SignalQuery } from '@awork/core/state/signal-store/signalQuery'

@Injectable({ providedIn: 'root' })
export class TaskSettingsQuery extends SignalQuery<TaskSettings> {
  protected store: TaskSettingsStore

  constructor() {
    const store = inject(TaskSettingsStore)

    super(store)

    this.store = store
  }

  /**
   * Gets task settings from the store
   * @returns {TaskSettings}
   */
  getTaskSettings(): TaskSettings {
    return this.getValue()
  }
}
